import React from 'react';
import { ArrowUpRightIcon, ShieldCheckIcon } from 'lucide-react';
import { partners } from '../data/strategy';
export function PropFirmBanner() {
  return <section id="fondeo" aria-labelledby="prop-firm-title" className="border-b border-line" data-id="element-55" data-mp="cjvzepysifkz">
      <div className="mx-auto grid w-full max-w-[1400px] gap-8 px-5 py-12 sm:px-6 lg:grid-cols-12 lg:items-center lg:gap-10 lg:px-10 lg:py-16" data-id="element-56" data-mp="2s01bewpepgr">
        <div className="lg:col-span-5" data-id="element-57" data-mp="3kwtkbn4qxegr">
          <div className="flex items-center gap-2" data-id="element-58" data-mp="3kzzaz6t0woel">
            <ShieldCheckIcon className="h-4 w-4 shrink-0 text-gold-vip" aria-hidden="true" data-id="element-59" data-mp="3p09co79s8snn" />
            <span id="prop-firm-title" className="font-mono text-[10px] uppercase tracking-[0.2em] text-gold-vip sm:text-[11px] sm:tracking-[0.22em]" data-id="element-60" data-mp="3b1jhwyafr52g">
              Prop Firm Ready
            </span>
          </div>
          <p className="mt-4 max-w-lg text-[14px] leading-relaxed text-white/60 sm:text-[15px]" data-id="element-61" data-mp="1e7ezun4k9pdz">
            Estrategia optimizada para superar evaluaciones de fondeo gracias al
            control estricto de Drawdown. Compatible con FTMO, Topstep y
            MyFundedFX.
          </p>
          <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.16em] text-white/25" data-id="element-62" data-mp="1jej2otmgnzti">
            Cuentas recomendadas · enlaces de afiliado
          </p>
        </div>

        <ul className="grid gap-px bg-line sm:grid-cols-3 lg:col-span-7" data-id="element-63" data-mp="rmturpat0u3x">
          {partners.map(partner => <li key={partner.name} className="bg-ink" data-id="element-64" data-mp="moa4jcp6gw5r">
              <a href={partner.href} target="_blank" rel="noopener noreferrer sponsored" className="group flex h-full flex-col justify-between gap-4 px-5 py-5 transition-colors duration-150 ease-out hover:bg-white/[0.04] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-cyan-vip" data-id="element-65" data-mp="mptlz6mkld94">
                <div data-id="element-66" data-mp="2732c5ch8yin6">
                  <span className="font-mono text-[9px] uppercase tracking-[0.2em] text-cyan-vip" data-id="element-67" data-mp="275ohd5go0m28">
                    {partner.category}
                  </span>
                  <span className="mt-2 block text-[15px] font-semibold leading-tight tracking-tight text-white/90 sm:text-[16px]" data-id="element-68" data-mp="19o7jwl88rg0z">
                    {partner.name}
                  </span>
                  <span className="mt-1 block font-mono text-[10px] leading-snug text-white/35" data-id="element-69" data-mp="1iow1fpwufyim">
                    {partner.note}
                  </span>
                </div>

                <span className="mt-auto inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.14em] text-white/45 transition-colors duration-150 ease-out group-hover:text-cyan-vip" data-id="element-70" data-mp="q0rtsyuppbda">
                  Abrir cuenta
                  <ArrowUpRightIcon className="h-3.5 w-3.5 transition-transform duration-150 ease-out group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-71" data-mp="zsnt2d8jb7j3" />
                </span>
              </a>
            </li>)}
        </ul>
      </div>
    </section>;
}